// extracted by mini-css-extract-plugin
export default {"custom-calendar-header":"styles_custom-calendar-header__gXa2k"};